import React from "react";
import { Helmet } from "react-helmet-async";
import 'bootstrap-icons/font/bootstrap-icons.css';

const PrivacyPolicy = () => {
  return (
    <div className="container py-5 px-3">
      {/* SEO Meta Tags */}
  
  <Helmet>
  <title>Privacy Policy - LuvMarry | Indian Matrimony </title>
  
  <meta
    name="description"
    content="Read the Privacy Policy of LuvMarry, the #1  matrimony platform. Learn how we collect, protect, and use your data securely while helping you find your perfect match."
  />
  
  <meta
    name="keywords"
    content="LuvMarry Privacy Policy, Indian dating privacy, matrimony privacy , user data protection, secure marriage platform, NRI matchmaking privacy, Indian singles security, privacy policy, data rights Indian matrimony"
  />
  
  <meta name="robots" content="index, follow" />
  <link rel="canonical" href="https://luvmarry.com/PrivacyPolicy" />

  {/* Open Graph */}
  <meta property="og:title" content="Privacy Policy - LuvMarry Indian Matrimony" />
  <meta 
    property="og:description" 
    content="Understand how LuvMarry, a trusted Indian matrimony and dating site, collects, stores, and safeguards your data with complete transparency." 
  />
  <meta property="og:image" content="/LuvMarryLogoPink.png" />
  <meta property="og:url" content="https://luvmarry.com/PrivacyPolicy" />
  <meta property="og:type" content="website" />

  {/* Twitter Card */}
  <meta name="twitter:card" content="summary_large_image" />
  <meta name="twitter:title" content="Privacy Policy - LuvMarry | Secure Indian Matrimony" />
  <meta 
    name="twitter:description" 
    content="Learn how LuvMarry ensures data security and user privacy while connecting Indian singles for marriage." 
  />
  <meta name="twitter:image" content="/LuvMarryLogoPink.png" />
</Helmet>


      {/* Header */}
      <div className="text-center mb-4">
        <img
          src="/LuvMarryLogoPink.png"
          alt="LuvMarry Logo"
          width="60"
          height="60"
          style={{ marginBottom: "10px" }}
        />
        <h1
          className="fw-bold"
          style={{
            color: "#e91e63",
            fontFamily: "'Great Vibes', cursive",
            fontSize: "2.3rem",
          }}
        >
          Privacy Policy
        </h1>
        <p className="text-muted">Effective Date: January 2025</p>
      </div>

      {/* Main Content */}
      <div className="bg-white shadow-lg rounded-4 p-4">
        <section className="mb-4">
          <h2 className="fw-bold text-dark">
            <i className="bi bi-shield-lock-fill text-danger me-2"></i>
            1. Information We Collect
          </h2>
          <p>
            We collect personal information such as your name, email, photos,
            profile details, and location. We also collect usage data like IP
            address and activity logs to ensure a secure platform.
          </p>
        </section>

        <section className="mb-4">
          <h2 className="fw-bold text-dark">
            <i className="bi bi-hand-thumbs-up-fill text-pink me-2"></i>
            2. How We Use Your Information
          </h2>
          <ul>
            <li>Provide, improve, and personalize your experience.</li>
            <li>Match you with compatible profiles.</li>
            <li>Ensure platform safety and prevent fraud.</li>
          </ul>
        </section>

        <section className="mb-4">
          <h2 className="fw-bold text-dark">
            <i className="bi bi-share-fill text-primary me-2"></i>
            3. Sharing of Information
          </h2>
          <p>
            We do not sell your data. We may share information with trusted
            service providers or when required by law.
          </p>
        </section>

        <section className="mb-4">
          <h2 className="fw-bold text-dark">
            <i className="bi bi-pencil-square text-success me-2"></i>
            4. Your Choices & Rights
          </h2>
          <p>
            You can edit or delete your profile anytime. If you request account deletion or a copy of your data, we will process your request within <strong>3 working days</strong>. Please contact us to initiate this.
          </p>
        </section>

        <section className="mb-4">
          <h2 className="fw-bold text-dark">
            <i className="bi bi-lock-fill text-dark me-2"></i>
            5. Data Security
          </h2>
          <p>
            We encrypt sensitive details and implement strict security measures to protect your information. However, please remain cautious when sharing personal data online.
          </p>
        </section>

        <section className="mb-4">
          <h2 className="fw-bold text-dark">
            <i className="bi bi-person-fill-slash text-warning me-2"></i>
            6. Children’s Privacy
          </h2>
          <p>
            LuvMarry is strictly for individuals 18+ years old. We do not
            knowingly collect data from minors.
          </p>
        </section>

        <section className="mb-4">
          <h2 className="fw-bold text-dark">
            <i className="bi bi-arrow-repeat text-secondary me-2"></i>
            7. Updates to This Policy
          </h2>
          <p>
            We may update this Privacy Policy periodically. 
            Please check this page regularly for the latest version.
          </p>
        </section>

        <section>
          <h2 className="fw-bold text-dark">
            <i className="bi bi-envelope-fill text-danger me-2"></i>
            8. Contact Us
          </h2>
          <p>
            For questions or abuse reports, please email us at: <br />
            <strong>customercare@luvmarry.com</strong>
          </p>
        </section>
      </div>

      {/* Back Button */}
      <div className="text-center mt-4">
        <a
          href="/"
          className="btn btn-lg px-4"
          style={{
            background: "#e91e63",
            color: "#fff",
            borderRadius: "50px",
            fontWeight: "bold",
          }}
        >
          <i className="bi bi-house-door-fill me-2"></i>Back to Home
        </a>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
